import React from 'react';
import styled, { keyframes } from 'styled-components';

const GalleryDiv = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    margin: 10px;
`;

const shake_anim = keyframes`
    0% { transform: rotate(-3deg); }
    50% { transform: rotate(3deg); } 
    100% { transform: rotate(-3deg); }
`;

const ImgDiv = styled.div`
    background: url(${props => props.ImgUrl}) no-repeat center;
    background-size: contain;
    background-position: center;
    cursor: pointer;
    width: 100%;
    height: 230px;
    border: 1px solid #d2d2d2;
    &.delete_me {
        animation: ${shake_anim} 0.5s linear infinite;
    }
    &:hover {
        opacity: 0.7;
    }
`;

class Gallery extends React.Component {
    renderImage(image, index, delete_mode) {
        const base64image = btoa(
            new Uint8Array(image.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                '',
            ),
        );
        const imageUrl = `data:${image.type};base64,${base64image}`;

        const openImageFn = () => {
            const image = new Image();
            image.src = imageUrl;
            const w = window.open('');
            w.document.write(image.outerHTML);
            w.document.close();
        };
        if (image.type.includes('image')) {
            return (
                <ImgDiv
                    className={`${delete_mode ? 'delete_me' : ''}`}
                    ImgUrl={imageUrl}
                    key={`photo_${index}`}
                    onClick={() => {
                        delete_mode ? this.props.onDelete(image.id) : openImageFn();
                    }}
                />
            );
        }
    }

    render() {
        this.img = styled.div`
            border-style: solid;
            border-width: ${this.props.delete_mode ? '20px' : '0px'};
            cursor: ${this.props.delete_mode ? 'pointer' : 'default'};
            margin-left: 5px;
            border-color: red;
        `;
        return (
            <GalleryDiv>
                {this.props.images.map((image, index) =>
                    this.renderImage(image, index, this.props.delete_mode),
                )}
            </GalleryDiv>
        );
    }
}
export default Gallery;



// WEBPACK FOOTER //
// ./src/components/base/Gallery.jsx